import ace from 'ace-builds';

import modeJsonUrl from 'ace-builds/src-noconflict/mode-json?url';
ace.config.setModuleUrl('ace/mode/json', modeJsonUrl);

import modeJavascriptUrl from 'ace-builds/src-noconflict/mode-javascript?url';
ace.config.setModuleUrl('ace/mode/javascript', modeJavascriptUrl);

import modeHtmlUrl from 'ace-builds/src-noconflict/mode-html?url';
ace.config.setModuleUrl('ace/mode/html', modeHtmlUrl);

import modeYamlUrl from 'ace-builds/src-noconflict/mode-yaml?url';
ace.config.setModuleUrl('ace/mode/yaml', modeYamlUrl);

// No built-in Jinja2 mode ships with ace-builds — django is the closest
// match (same {{ }}/{% %} delimiter syntax) and is what the Advanced
// Template editor (TemplateBindingEditor.vue) uses for highlighting.
import modeDjangoUrl from 'ace-builds/src-noconflict/mode-django?url';
ace.config.setModuleUrl('ace/mode/django', modeDjangoUrl);

import themeGithubUrl from 'ace-builds/src-noconflict/theme-github?url';
ace.config.setModuleUrl('ace/theme/github', themeGithubUrl);

import themeChromeUrl from 'ace-builds/src-noconflict/theme-chrome?url';
ace.config.setModuleUrl('ace/theme/chrome', themeChromeUrl);

import themeMonokaiUrl from 'ace-builds/src-noconflict/theme-monokai?url';
ace.config.setModuleUrl('ace/theme/monokai', themeMonokaiUrl);

import themeOneDarkUrl from 'ace-builds/src-noconflict/theme-one_dark?url';
ace.config.setModuleUrl('ace/theme/one_dark', themeOneDarkUrl);

import themeDraculaUrl from 'ace-builds/src-noconflict/theme-dracula?url';
ace.config.setModuleUrl('ace/theme/dracula', themeDraculaUrl);

import themeTomorrowNightUrl from 'ace-builds/src-noconflict/theme-tomorrow_night?url';
ace.config.setModuleUrl('ace/theme/tomorrow_night', themeTomorrowNightUrl);

import themeNordDarkUrl from 'ace-builds/src-noconflict/theme-nord_dark?url';
ace.config.setModuleUrl('ace/theme/nord_dark', themeNordDarkUrl);

import themeGithubDarkUrl from 'ace-builds/src-noconflict/theme-github_dark?url';
ace.config.setModuleUrl('ace/theme/github_dark', themeGithubDarkUrl);

import themeCobaltUrl from 'ace-builds/src-noconflict/theme-cobalt?url';
ace.config.setModuleUrl('ace/theme/cobalt', themeCobaltUrl);

import themeSolarizedDarkUrl from 'ace-builds/src-noconflict/theme-solarized_dark?url';
ace.config.setModuleUrl('ace/theme/solarized_dark', themeSolarizedDarkUrl);

import themeSolarizedLightUrl from 'ace-builds/src-noconflict/theme-solarized_light?url';
ace.config.setModuleUrl('ace/theme/solarized_light', themeSolarizedLightUrl);

import themeXcodeUrl from 'ace-builds/src-noconflict/theme-xcode?url';
ace.config.setModuleUrl('ace/theme/xcode', themeXcodeUrl);

import themeDawnUrl from 'ace-builds/src-noconflict/theme-dawn?url';
ace.config.setModuleUrl('ace/theme/dawn', themeDawnUrl);

import workerBaseUrl from 'ace-builds/src-noconflict/worker-base?url';
ace.config.setModuleUrl('ace/mode/base', workerBaseUrl);

import workerJsonUrl from 'ace-builds/src-noconflict/worker-json?url';
ace.config.setModuleUrl('ace/mode/json_worker', workerJsonUrl);

import workerJavascriptUrl from 'ace-builds/src-noconflict/worker-javascript?url';
ace.config.setModuleUrl('ace/mode/javascript_worker', workerJavascriptUrl);

import workerHtmlUrl from 'ace-builds/src-noconflict/worker-html?url';
ace.config.setModuleUrl('ace/mode/html_worker', workerHtmlUrl);

import workerYamlUrl from 'ace-builds/src-noconflict/worker-yaml?url';
ace.config.setModuleUrl('ace/mode/yaml_worker', workerYamlUrl);

import snippetsHtmlUrl from 'ace-builds/src-noconflict/snippets/html?url';
ace.config.setModuleUrl('ace/snippets/html', snippetsHtmlUrl);

import snippetsJsUrl from 'ace-builds/src-noconflict/snippets/javascript?url';
ace.config.setModuleUrl('ace/snippets/javascript', snippetsJsUrl);

import snippetsYamlUrl from 'ace-builds/src-noconflict/snippets/yaml?url';
ace.config.setModuleUrl('ace/snippets/javascript', snippetsYamlUrl);

import snippetsJsonUrl from 'ace-builds/src-noconflict/snippets/json?url';
ace.config.setModuleUrl('ace/snippets/json', snippetsJsonUrl);

import extSearchboxUrl from 'ace-builds/src-noconflict/ext-searchbox?url';
ace.config.setModuleUrl('ace/ext/searchbox', extSearchboxUrl);

import 'ace-builds/src-noconflict/ext-language_tools';
ace.require("ace/ext/language_tools");